import React, { Component } from 'react';
import PropTypes from 'prop-types';

import './FieldsContainer.css';

class FieldsContainer extends Component {
  static get propTypes() {
    return {
      children: PropTypes.arrayOf(PropTypes.any)
    };
  }

  render() {
    const { children } = this.props;
    return (
      <div className="FieldsContainer">
        {children}
      </div>
    );
  }
}

export default FieldsContainer;



// WEBPACK FOOTER //
// ./src/recordDetail/fields/FieldsContainer.js